export const fetchMedias = resp => ({
  type: "FETCH_MEDIAS",
  payload: resp
});

export const fetchTopMedias = resp => ({
  type: "FETCH_TOP_MEDIAS",
  payload: resp
});

export const fetchUsedMedias = resp => ({
  type: "FETCH_USED_MEDIAS",
  payload: resp
});

export const initUsedMedias = () => {
  return {
    type: "INIT_USED_MEDIAS"
  };
};

export const resetMediasByType = (type = "ALL") => ({
  type: `RESET_MEDIAS_${type.toUpperCase()}`
});

export const fetchMediasByType = (type = "ALL") => resp => ({
  type: `FETCH_MEDIAS_${type.toUpperCase()}`,
  payload: resp,
  append: true
});

export const fetchInfiniteMediasByType = (type = "ALL") => resp => ({
  type: `FETCH_INFINITE_MEDIAS_${type.toUpperCase()}`,
  payload: resp
});

export const saveMedia = resp => ({
  type: "SAVE_MEDIA",
  payload: resp
});

export const addUploadingMedias = items => ({
  type: "ADD_UPLOADING_MEDIAS",
  items
});

export const setUploadingMedias = items => ({
  type: "SET_UPLOADING_MEDIAS",
  items
});

export const unshiftUsedMedia = media => ({
  type: "UNSHIFT_USED_MEDIA",
  media
});

export const deleteFromListMedia = (type = "ALL", media) => ({
  type: `DELETE_FROM_LIST_MEDIA_${type.toUpperCase()}`,
  media
});

export const addToLibrary = resp => ({
  type: "ADD_TO_LIBRARY",
  payload: resp
});

export const toggleSelectMedia = media => ({
  type: "TOGGLE_SELECT_MEDIA",
  payload: media
});

export const resetSelectedMedia = () => ({
  type: "RESET_SELECTED_MEDIA"
});

export const setAddMediaModalOpened = visible => ({
  type: "SET_ADD_MEDIA_MODAL_OPENED",
  payload: visible
});

export const setMediasFilter = filter => ({
  type: "SET_MEDIAS_FILTER",
  payload: filter
});

export const setOpenDeleteConfirm = visible => ({
  type: "SET_OPEN_DELETE_CONFIRM",
  payload: visible
});

export const deleteMedias = resp => ({
  type: "DELETE_MEDIAS",
  payload: resp
});

export const maskMedias = resp => ({
  type: "MASK_MEDIAS",
  payload: resp
});

export const archiveMedias = resp => ({
  type: "ARCHIVE_MEDIAS",
  payload: resp
});



// WEBPACK FOOTER //
// ./src/actions/actions/media.js